module.exports = __webpack_public_path__ + "img/portfolio-big-03.8dee6369.jpg";